<p-confirmDialog header="Atenção"
  icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-messages></p-messages>
<habil-grupo>
  <div class="p-fluid p-grid">

    <div class="p-col-2">
      <habil-label name="dtInicial"
        label="Data Inical">
        <habil-date-edit name="dtInicial"
          [(ngModel)]="dataInicial"></habil-date-edit>
      </habil-label>
    </div>
    <div class="p-col-2">
      <habil-label name="dtFinal"
        label="Data Final">
        <habil-date-edit name="dtFinal"
          [(ngModel)]="dataFinal"></habil-date-edit>
      </habil-label>
    </div>
     <div class="p-col-fixed p-col-align-center">
      <br>
      <p-checkbox [(ngModel)]="excluidos" [binary]="true" label="Buscar Excluídos"></p-checkbox>
    </div>
    <div class="p-col-fixed p-col-align-end">
      <button pButton
        icon="pi pi-search"
        [loading]="loading"
        (click)="buscar()"
        label="Carregar Dados"></button>
    </div>

    <div class="p-col-fixed p-col-align-end">
      <button pButton
        class="p-button-danger"
        icon="pi pi-trash"
        [loading]="loading"
        (click)="excluir()"
        label="Apagar selecionados"></button>
    </div>
    <div class="p-col-12">
      <p-table [value]="list"
        selectionMode="multiple"
        [(selection)]="selected"
        scrollHeight="calc(100svh - 200px)"
        [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 4rem"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
            <th pSortableColumn="data">Data</th>
            <th pSortableColumn="dataExclusao">Exclusao</th>
            <th pSortableColumn="nome">Nome</th>
            <th pSortableColumn="chef">Tipo</th>
            <th pSortableColumn="cnpj">CNPJ</th>
            <th pSortableColumn="modulo">Módulo</th>
            <th pSortableColumn="validade">Validade</th>
            <th pSortableColumn="classificacao">Classificação</th>
            <th pSortableColumn="ultimoAcesso">Último acesso</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body"
          let-item
          let-rowIndex="rowIndex">
          <tr [pSelectableRow]="item"
            [pSelectableRowIndex]="rowIndex">
            <td>
              <p-tableCheckbox [value]="item"
                [pSelectableRow]="item"></p-tableCheckbox>
            </td>
            <td>{{ item.data | date: 'dd/MM/yyy' }}</td>
            <td>{{ item.dataExclusao | date: 'dd/MM/yyy HH:mm' }}</td>
            <td>{{ item.nome }}</td>
            <td>{{ (item.chef ? 'CHEF' : 'H10') }}</td>
            <td>{{ item.cnpj }}</td>
            <td>{{ item.modulo }}</td>
            <td>{{ item.validade | date: 'dd/MM/yyy' }}</td>
            <td>{{ item.classificacao }}</td>
            <td>{{ item.ultimoAcesso | date: 'dd/MM/yyy HH:mm' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </div>
</habil-grupo>